const ru = {
  welcome: `Добро пожаловать`,
  description: `UXCP - это единственный общедоступный инструмент, который анализирует мышление людей на основе их когнитивных искажений. Вы создаете профили ("Персоны"), давая им имена и выбирая когнитивные искажения, которые им свойственны. Эти профили могут представлять как отдельных людей, так и группы - от конкретных личностей до широких категорий, таких как "Женская аудитория" или "Канадцы". Система анализирует 105 различных когнитивных искажений по 63 управленческим вопросам.`,
  descriptionLink: {
    info: 'Полное описание этого инструмента вы можете найти ',
    title: 'на Medium по этой ссылке.',
    target: '_target',
    href: 'https://habr.com/ru/post/670722/',
  },
  exampleText: 'Примеры Персоны',
  exampleMobileText: 'Примеры Персоны',
  examples: [
    {
      title: 'Steve Jobs',
      link: 'https://google.com/search?q=Steve Jobs',
    },
    {
      title: 'Warren Buffett',
      link: 'https://google.com/search?q=Warren Buffett',
    },
    {
      title: 'Barak Obama',
      link: 'https://google.com/search?q=Barak Obama',
    },
    {
      title: 'Uber_user_Middle_East',
      link: 'https://google.com/search?q=Uber_user_Middle_East',
    },
    {
      title: 'iPhone_user_Somali',
      link: 'https://google.com/search?q=iPhone_user_Somali',
    },
    {
      title: 'Twitter_crypto_influencer',
      link: 'https://google.com/search?q=Twitter_crypto_influencer',
    },
    {
      title: 'Twitter_politician',
      link: 'https://google.com/search?q=Twitter_politician',
    },
  ],
  title: `Билдер Персоны`,
  sectionTitle: `Свойственные персоне когнитивные искажения`,
  analyzeTeamMemeber: `Анализировать как участника команды?`,
  analyzeTeamMemeberTooltip: `Если выбрано, система выделит наиболее важные искажения свойственные персоне в контексте работы с персоной в одной команде.`,
  personaInputLabel: 'Имя персоны',
  personaInputPlaceholder: 'Джон Доу',
  personaInputMobilePlaceholder: 'Имя персоны',
  biasSearchPlaceholder: 'Поиск',
  biasSearchTip: 'Введите название искажения, часть его описания или примера',
  addButtonText: 'Добавить',
  showAllText: 'Показать все',
  yes: `Да`,
  no: `Нет`,
  subSectionTitle: `Результаты анализа`,
  suggestedQuestionsTitle: `Вопросы на которые рекомендуется обратить внимание`,
  suggestedQuestionsDescription: `Система обнаружила один или более вопросов которые не связаны с выбранными вами искажениями, но которые часто встречаются в релевантных Персоне вопросах. Рекомендуется принять во внимание эти вопросы в вашем исследовании.`,
  teamRelatedInsightsTitle: `Результат анализа персоны как участника команды`,
  teamRelatedInsightsDescription1: `Опция "Анализировать как участника команды" активирована. В этой секции система отфильтрует выбранные вами искажения, оставив лишь те, которые наиболее релевантны при работе с данной персоной в команде. `,
  teamRelatedInsightsDescription2: ` как участника команды.`,
  questionHighRelevancyText: `Высокая релевантность Персоне`,
  questionMediumRelevancyText: `Средняя релевантность Персоне`,
  questionLowRelevancyText: `Низкая релевантность Персоне`,
  noData: `Нет данных`,
  pieChartSectionTitle: `Вопросы релевантные персоне по стадиям продукта`,
  personaRelatedQuestionsTitle: `Вопросы релевантные персоне`,
  relevancyLevel: `Уровень релевантности`,
  relevancyLevelHint: `Релевантность считается на основе количества одинаковых вопросов встречающихся в выбранных вами искажениях`,
  all: `Все`,
  highPriority: `Высокий`,
  mediumPriority: `Средний`,
  lowPriority: `Низкий`,
  and: `И`,
  other: `другое`,
  pageTitle: `Страница`,
  questionLabel: `вопрос`,
  appearsIn1: 'Встречается в ',
  appearsInPersonaRelatedQuestions: '% вопросов релевантных персоне (',
  appearsInSelectedBiases: '% из выбранных искажений (',
  appearsIn2: ' из ',
  appearsIn3: ')',
  pieChartPlaceholder: 'Выберите категорию вопросов',
  biasPlaceholder: 'Добавьте искажение чтобы начать',
  copyURL: 'Скопировать',
  copied: 'Скопировано!',
  mobileDisclimer: 'Persona builder is available only on Desktop',
  searchResultText1: 'найден',
  searchResultText2: 'результат',
  stage: 'стадия',
  biasPopupCustomTip:
    'Кликните на номер искажения, чтобы ознакомиться с ним в UX Core (откроется в новой вкладке)',
};

export default ru;
